// extracted by mini-css-extract-plugin
module.exports = {"box":"Tip_box_4BXMq","tip":"Tip_tip_1ZrTz","close":"Tip_close_cBuzm","title":"Tip_title_19Zi4","info":"Tip_info_2XAhH"};